import logo from "../../assets/logo.svg";
import { Linkedin, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-lightBlue text-white py-10 px-4 md:px-6 border-y border-white">
      <div className="mx-auto grid grid-cols-1 md:grid-cols-4 gap-10 items-start max-w-[2400px]">
        {/* Logo + Tagline */}
        <div className="md:col-span-2 text-center md:text-left">
          <div className="flex items-center space-x-2 mb-3">
            <img
              src={logo}
              alt="Ledgerate Logo"
              className="h-24 max-md:mx-auto"
            />
          </div>
          <p className=" text-gray-300 max-md:px-5 md:ml-8 -m-6">
            Transforming Messy Sales Data Into Bookkeeper-Ready Spreadsheets.
          </p>
        </div>

        {/* Quick Links */}
        <div className="">
          <h4 className="font-semibold mb-2">Quick Links</h4>
          <ul className="space-y-1 max-md:text-4xl text-gray-300">
            {["Features", "How It Works", "Integrations"].map((link, index) => (
              <li
                key={index}
                className=" hover:text-white max-md:border-b-2 max-md:py-4 max-md:border-white max-md:pb-1 px-2"
              >
                <a
                  href={`#${link.toLowerCase().replace(/\s+/g, "")}`}
                  className=""
                >
                  {link}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact CTA */}
        <div className="text-center md:text-start text-base md:text-lg">
          <h4 className="font-semibold mb-2">Contact</h4>
          <div className="flex justify-center md:justify-start gap-4 mt-2">
            {/* LinkedIn Icon */}
            <a
              href="https://www.linkedin.com/company/ledgerate/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-lightGreen transition"
            >
              <Linkedin size={28} />
            </a>

            {/* Email Icon */}
            <button
              onClick={() =>
                document
                  .getElementById("contact")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
              className="text-white hover:text-lightGreen transition"
            >
              <Mail size={28} />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
